export const lowercaseObjectProperties = function lowercaseObjectProperties(obj) {
    if (obj instanceof Array) {
        for (const element of obj) {
            lowercaseObjectProperties(element);
        }
    } else if (obj instanceof Object) {
        Object.keys(obj).forEach((key) => {
            const lowerKey = key.toLowerCase();
            if (lowerKey !== key) {
                obj[lowerKey] = obj[key];
                lowercaseObjectProperties(obj[lowerKey]);
            }
        });
    }
};
